import { render, staticRenderFns } from "./index.vue?vue&type=template&id=48f0e2c9&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=48f0e2c9&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../szc.cycz.cc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f0e2c9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/szc.cycz.cc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48f0e2c9')) {
      api.createRecord('48f0e2c9', component.options)
    } else {
      api.reload('48f0e2c9', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=48f0e2c9&scoped=true", function () {
      api.rerender('48f0e2c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/createQuotation/index.vue"
export default component.exports